module.exports = __webpack_public_path__ + "static/img/unionpay.883d613c.png";